import React, { useState, useEffect } from "react";
import { Dropdown } from "@hid-galaxy-ui/galaxy-react";
import "../ReportDetail.scss";

export type AccessInfo = {
  viewOnly: string[];
  edit: string[];
};

export type ReportCategoryAccessProps = {
  categoriesList: string[];
  initialCategory?: string;
  accessInfo: AccessInfo;
  onCategoryChange?: (category: string) => void;
  onEditAccess?: () => void;
};

const ReportCategoryAccess: React.FC<ReportCategoryAccessProps> = ({
  categoriesList,
  initialCategory,
  accessInfo,
  onCategoryChange,
  onEditAccess,
}) => {
  const [selectedCategory, setSelectedCategory] = useState<string>(initialCategory || "");

  useEffect(() => {
    setSelectedCategory(initialCategory || "");
  }, [initialCategory]);

  const handleChange = (option: { label: string; value: string }) => {
    setSelectedCategory(option.value);
    onCategoryChange?.(option.value);
  };

  // Format categories for the dropdown
  const formattedCategories = categoriesList.map((cat) => ({ label: cat, value: cat }));

  return (
    <div className="rd-ca-card"  style={{ marginBottom: 24 }}>
      <div className="rd-ca-card__row">
        <span className="rd-ca-card__label">Category</span>
        <div className="rd-ca-card__value">
          <Dropdown
            id="category-dropdown"
            options={formattedCategories}
            value={{ label: selectedCategory, value: selectedCategory }}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="rd-ca-card__row">
        <span className="rd-ca-card__label">Access</span>
        <div className="rd-ca-card__value">
          <span className="rd-ca-access">
            <strong>View Only</strong> 
            {accessInfo.viewOnly.map((role, idx) => (
              <span key={idx} className="rd-ca-access-single">{role}</span>
            ))}
          </span>
          <span className="rd-ca-access">
            <strong>Edit</strong> 
            {accessInfo.edit.map((role, idx) => (
              <span key={idx} className="rd-ca-access-single">{role}</span>
            ))}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ReportCategoryAccess;
